import { useState } from "preact/hooks";

/**
 * A filter value remembered per browser (localStorage). Storage can be blocked or empty in a
 * private window, so every access is guarded and an unreadable or unknown value falls back.
 */
const PREFIX = "tenergy.admin.";

export function readChoice<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  try {
    const value = window.localStorage.getItem(PREFIX + key);
    return value !== null && (allowed as readonly string[]).includes(value) ? (value as T) : fallback;
  } catch {
    return fallback;
  }
}

export function saveChoice(key: string, value: string): void {
  try {
    window.localStorage.setItem(PREFIX + key, value);
  } catch {
    // Not remembered this time; the filter still works.
  }
}

export function useRememberedChoice<T extends string>(key: string, allowed: readonly T[], fallback: T): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => readChoice(key, allowed, fallback));
  return [
    value,
    (next: T) => {
      setValue(next);
      saveChoice(key, next);
    },
  ];
}
